import React from "react";
import { object } from "prop-types";

import NumberedCardWithImage from "../../molecules/NumberedCardWithImage";
import ComponentContainer from "../../layouts/component-container";

import "./numberedNewsCard.m.css";

const NumberedNewsCard = ({ collection }) => {
  if (!collection?.items?.length) return null;

  const { items = [] } = collection;

  const stories = items.reduce((accumulator, item) => {
    if (item.type === "story") {
      accumulator.push(item.story);
    }
    return accumulator;
  }, []);

  if (!stories.length) return null;

  const columnStyle = {
    "--number-of-rows": Math.ceil(stories.length / 2),
  };

  return (
    <div styleName="numbered-news-card">
      <ComponentContainer collection={collection}>
        <div styleName="scroll-box">
          <div styleName="wrapper" style={columnStyle}>
            {stories.map((story, index) => (
              <NumberedCardWithImage key={index} story={story} headlineNumber={index + 1} />
            ))}
          </div>
        </div>
      </ComponentContainer>
    </div>
  );
};

NumberedNewsCard.storyLimit = 8;

NumberedNewsCard.propTypes = {
  collection: object.isRequired,
};

export default NumberedNewsCard;
